import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-system-monitor',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './system-monitor.html',
  styleUrl: './system-monitor.css'
})
export class SystemMonitorComponent implements OnInit, OnDestroy {
  cpuUsage = 42;
  memUsage = 68;
  diskUsage = 34;
  netTraffic = 1.2;

  logs = [
    { time: '14:24:01', level: 'INFO', message: 'System startup sequence initiated for Node-04', source: 'Core' },
    { time: '14:24:05', level: 'INFO', message: 'Connected to primary database cluster (Europe-West)', source: 'DB' },
    { time: '14:24:12', level: 'WARN', message: 'High latency detected on Redis cache (85ms)', source: 'Cache' },
    { time: '14:25:00', level: 'ERROR', message: 'Failed to sync content to edge node Edge-TK2', source: 'CDN' },
    { time: '14:25:30', level: 'INFO', message: 'Retry successful for edge node Edge-TK2', source: 'CDN' },
    { time: '14:26:10', level: 'INFO', message: 'User authentication service scaled up (+2 instances)', source: 'K8s' },
    { time: '14:28:44', level: 'INFO', message: 'Garbage collection completed (freed 1.2GB)', source: 'Core' },
  ];

  private intervalId: any;

  ngOnInit() {
    // Simulate real-time metrics updates
    this.intervalId = setInterval(() => {
      this.cpuUsage = Math.min(100, Math.max(0, this.cpuUsage + (Math.random() * 10 - 5)));
      this.memUsage = Math.min(100, Math.max(0, this.memUsage + (Math.random() * 4 - 2)));
      this.netTraffic = Math.max(0.1, +(this.netTraffic + (Math.random() * 0.4 - 0.2)).toFixed(1));
    }, 2000);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  getLogClass(level: string): string {
    switch (level) {
      case 'ERROR': return 'text-red-400';
      case 'WARN': return 'text-yellow-400';
      default: return 'text-blue-400';
    }
  }
}
